export default {
  为您找到: '为您找到',
  未知模块: '未知模块',
  相关: '相关',
  结果: '结果',
  抱歉没有找到: '抱歉没有找到',
  一键已读: '一键已读',
  暂无相关的云数据: '暂无相关的云数据',
}
